/**
 * @generated SignedSource<<8304819e680d3a0272efb839f7fcd4ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type KPIEditSectionsComponentSubItemListItem_Team$data = {
  readonly color: string | null;
  readonly name: string;
  readonly " $fragmentType": "KPIEditSectionsComponentSubItemListItem_Team";
};
export type KPIEditSectionsComponentSubItemListItem_Team$key = {
  readonly " $data"?: KPIEditSectionsComponentSubItemListItem_Team$data;
  readonly " $fragmentSpreads": FragmentRefs<"KPIEditSectionsComponentSubItemListItem_Team">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "KPIEditSectionsComponentSubItemListItem_Team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "e78d155070e69ffab82f5ef9ae5bab79";

export default node;
